import { Suspense } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

type LoadingProviderProps = {
  children: React.ReactNode;
};

export default function LoadingProvider({ children }: LoadingProviderProps) {
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="primary" size={100} />
        </Box>
      }
    >
      {children}
    </Suspense>
  );
}
